export enum BadgeOptions {
    pro = "pro",
    verified = "verified",
    unverified = "unverified"
}